module.exports = __webpack_public_path__ + "img/share.e416a0e0.svg";